const creds = { token: null, refreshToken: null };
export default creds;
